import _ from 'lodash';
import { fork, put, select, takeLatest } from 'redux-saga/effects';
import { logError } from '@iwLogger/IwDataDogLogger';
import { CHANGE_ROUTER } from '../../iwRouter/IwRouter.actions';
import { registeredPages } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import {
    ACTIVATE_PAGE_NOT_FOUND,
    ENABLE_PAGE_NOT_FOUND
} from './PageNotFound.actions';

export const pageNotFoundSagaWorkers = [fork(pageNotFoundWorker)];

function* pageNotFoundWorker() {
    yield takeLatest(CHANGE_ROUTER, function* (action) {
        if (hasNoRegisteredLocation(action)) {
            const siteContext = yield select(({ siteContext }) => siteContext);
            yield logError(CHANGE_ROUTER, {
                tags: {
                    reporter: 'page_not_found',
                    impersonating: siteContext.impersonating,
                    stateKey: siteContext.impersonatingStateKey
                },
                extra: {
                    location: action.location
                }
            });
            yield put({ type: ENABLE_PAGE_NOT_FOUND });
            yield put({ type: ACTIVATE_PAGE_NOT_FOUND });
        }
    });
}

function hasNoRegisteredLocation(action) {
    // Exclude pages handled outside of Redux.
    const otherPages = [
        '/apply-flexi-loan/',
        '/my-offers/',
        '/funding-requirements/',
        '/confirm-funding/',
        '/CBILS/',
        '/iwocapay/',
        '/iwocapay/directory/',
        '/contracts/',
        '/history/'
    ];
    if (otherPages.includes(action.location.pathname)) {
        return false;
    }

    return _.every(
        registeredPages,
        (page) => !page.isInPageLocation(action.location)
    );
}
